import { formatDate, plural } from '@westhetics/ui'
import type { Network, NetworkListItem } from './api'

/** O que as clínicas da rede enxergam umas das outras, por extenso (RT-06). */
export function sharingLabel(sharesPatients: boolean) {
  return sharesPatients ? 'Leitura compartilhada' : 'Só da própria clínica'
}

/** "4 clínicas · leitura de pacientes compartilhada · criada em 02/05/2026" (ou "sem clínica · rede desativada"). */
export function identificationLine(
  network: Pick<Network, 'clinics' | 'sharesPatients' | 'createdAt'>,
) {
  const count = network.clinics.length
  return [
    count === 0 ? 'sem clínica · rede desativada' : plural(count, 'clínica'),
    network.sharesPatients
      ? 'leitura de pacientes compartilhada'
      : 'pacientes só da própria clínica',
    `criada em ${formatDate(new Date(network.createdAt))}`,
  ].join(' · ')
}

/** A contagem da coluna CLÍNICAS: "4" ou "nenhuma" na rede vazia. */
export function clinicCountLabel(network: Pick<NetworkListItem, 'clinicCount'>) {
  return network.clinicCount === 0 ? 'nenhuma' : String(network.clinicCount)
}
